import { Common } from '@stockbit/ui';
import Image from 'global/Image';
import { CAROUSEL_DATA } from './constants';
import {
  AuthModalCarousel,
  CarouselImage,
  CarouselItemContainer,
} from './styled';

const { Text } = Common;

export default function Carousel() {
  return (
    <div style={{ maxWidth: '100%' }}>
      <AuthModalCarousel
        autoplay
        arrows
        nextArrow={<Image src="/icon/next-arrow.svg" alt="next arrow" />}
        prevArrow={<Image src="/icon/prev-arrow.svg" alt="previous arrow" />}
      >
        {CAROUSEL_DATA.map(({ url, title, description }) => (
          <CarouselItemContainer>
            <CarouselImage alt={title} src={url} />
            <Text family="bold" align="center" size="20px">
              {title}
            </Text>
            <Text align="center" mt="12px" size="16px">
              {description}
            </Text>
          </CarouselItemContainer>
        ))}
      </AuthModalCarousel>
    </div>
  );
}
